import {
  CURRENCY_LIST_FAILED,
  CURRENCY_LIST_INVALID_TOKEN,
  CURRENCY_LIST_INVALID_REQUEST,
  CURRENCY_LIST_SUCCESS,
  RESET_CURRENCY_LIST,
} from "../types";

const initialState = {
  invalidToken: false,
  failed: false,
  invalidRequest: false,
  success: false,
  networkError: "",
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CURRENCY_LIST_FAILED:
      return {
        ...state,
        success: false,
        invalidToken: false,
        invalidRequest: false,
        failed: true,
        networkError: "",
        data: action.payload,
      };
    case CURRENCY_LIST_INVALID_REQUEST:
      return {
        ...state,
        success: false,
        invalidToken: false,
        invalidRequest: true,
        failed: false,
        networkError: "",
        data: action.payload,
      };
    case CURRENCY_LIST_SUCCESS: {
      const { currencyList, ...rest } = action.payload;
      return {
        ...state,
        failed: false,
        invalidToken: false,
        success: true,
        invalidRequest: false,
        networkError: "",
        data: {
          ...rest,
          currencyList: [].concat(currencyList),
        },
      };
    }

    case CURRENCY_LIST_INVALID_TOKEN:
      return {
        ...state,
        failed: false,
        invalidToken: true,
        success: false,
        invalidRequest: false,
        networkError: "",
        data: action.payload,
      };

    case RESET_CURRENCY_LIST:
      return (state = initialState);

    default:
      return state;
  }
};
